export const environment = {
  baseUrl: "/api/v1",
  baseUrlV2: "/api/v2",
  webSocketBaseUrl: "/ws/v1",
  webSocketBaseUrlV2: "/ws/v2",
  deviceManagementUrl: "/device/api/v1",
  mapTileUrl: {
    de: "https://api.mapbox.com/styles/v1/botevo/cmf5gfv24001l01qvfkrzgs1c/tiles/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYm90ZXZvIiwiYSI6ImNtZjVnM2R6bjA0eWMycXFxcHZnMzI2bHEifQ.NkluWj_iO35bDgbHHdsy8A",
    en: "https://api.mapbox.com/styles/v1/botevo/cmf5gilzc001c01sjbwgbbqz8/tiles/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYm90ZXZvIiwiYSI6ImNtZjVnM2R6bjA0eWMycXFxcHZnMzI2bHEifQ.NkluWj_iO35bDgbHHdsy8A",
  },
  mapConfig: { attributionControl: false },
};
